import { Bookmark } from "lucide-react";
import type { InteriorSample } from "../core/interiorSamples";
import type { Locale } from "../i18n";
import { sampleTitle } from "../home/model";
import { appShellCopy } from "../appShellContent";
import { discoveryContent } from "./content";
import { discoveryHref, type DiscoveryQuery } from "./model";

interface SampleCardProps {
  readonly sample: InteriorSample;
  readonly locale: Locale;
  readonly saved: boolean;
  readonly onSave: (id: string) => void;
  readonly query: DiscoveryQuery;
}
export function SampleCard({ sample, locale, saved, onSave, query }: SampleCardProps): React.JSX.Element {
  const t = discoveryContent(locale), shell = appShellCopy[locale], title = sampleTitle(sample, locale);
  return <article className="dc-card">
    <div className="dc-card-photo"><a href={discoveryHref(locale, { ...query, sample: sample.id })} aria-label={title}><img src={sample.imageUrl} alt={title} width={sample.width} height={sample.height} loading="lazy" /></a><span className="dc-photo-type">{t.origins[sample.origin]}</span><button type="button" className="dc-bookmark" aria-label={`${saved ? t.remove : t.save}: ${title}`} aria-pressed={saved} onClick={() => { onSave(sample.id); }}><Bookmark size={23} fill={saved ? "currentColor" : "none"} aria-hidden="true" /></button></div>
    <p className="dc-card-style">{shell.styles[sample.style]}</p><h3><a href={discoveryHref(locale, { ...query, sample: sample.id })}>{title}</a></h3><p className="dc-card-credit">{sample.author}</p><p className="dc-muted">{shell.locations[sample.location] ?? sample.location}</p>
  </article>;
}
